module.exports = __webpack_public_path__ + "static/multiweek-first-day-6fba56e485714ef0b6f089a8f4fce6cb.png";